import { takeLatest } from 'redux-saga/effects';
import {
	getJobRoleListSuccess, getJobRoleListFail,
	getJobRoleDetailsSuccess, getJobRoleDetailsFail,
} from './jobRoleState';
import createCrudService from '../../services/crudservice';
import { 
	doCrudCall, SAVING_MSG, UPDATING_MSG, DELETING_MSG, LOADING_MSG,
	createRecordSuccess, updateRecordSuccess, deleteRecordSuccess
} from '../../utils/crudSagaHelper';

const crudService = createCrudService('api/v1/recruitment/job-roles');
const redirectData = {route:'/console/job-roles', mode: 'list', recordId:0 };
const modelName = 'Job Role';
const modelId = 'jro_id';

function* getJobRoleList(data) {
	yield doCrudCall(
		() => crudService.getList(data.payload), 
		getJobRoleListSuccess, 
		getJobRoleListFail, null, null, LOADING_MSG);
}

function* getJobRoleDetails(data) {
	yield doCrudCall(
		() => crudService.getDetails(data.payload), 
		getJobRoleDetailsSuccess, 
		getJobRoleDetailsFail, 
		null, null, LOADING_MSG);		
}

function* doJobRoleCreate(data){
	yield doCrudCall(
		() => crudService.doCreate(data.payload), 
		getJobRoleDetailsSuccess, 
		getJobRoleDetailsFail,
		createRecordSuccess(modelName),
		{...redirectData, mode: "reload" },
		SAVING_MSG);
}

function* doJobRoleUpdate(data){
	yield doCrudCall(
		() => crudService.doUpdate(data.payload[modelId], data.payload), 
		getJobRoleDetailsSuccess, 
		getJobRoleDetailsFail,
		updateRecordSuccess(modelName),
		{...redirectData, mode: "reload" },
		UPDATING_MSG);	
}

function* doJobRoleDelete(data){
	yield doCrudCall(
		() => crudService.doDelete(data.payload.recordId), 
		getJobRoleDetailsSuccess, 
		getJobRoleDetailsFail,
		deleteRecordSuccess(modelName),
		{...redirectData, mode: data.payload.mode},
		DELETING_MSG);	
}

function* jobRoleSaga() {
	yield takeLatest('jobRole/getJobRoleList', getJobRoleList);
	yield takeLatest('jobRole/getJobRoleDetails', getJobRoleDetails);
	yield takeLatest('jobRole/doJobRoleCreate', doJobRoleCreate);
	yield takeLatest('jobRole/doJobRoleUpdate', doJobRoleUpdate);
	yield takeLatest('jobRole/doJobRoleDelete', doJobRoleDelete); 
}

export default jobRoleSaga;
